import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedConsts } from 'src/app/shared/constants';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';
import { StatePersistService } from '../services/state-persist.service';


@Injectable()

export class AuthGuard implements CanActivate {

    constructor(private router: Router, private statePersistService: StatePersistService, private sharedService: SharedService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentuser = this.statePersistService.getLocalStorage('currentUser')
        const maintenance_mode = environment.maintenanceMode
        if (!state.url.includes('/product/listing')){
            let data;
            data = this.statePersistService.getLocalStorage('product_data')
            if (data !== null){
                data['search_keyword'] = ''
                this.statePersistService.setLocalStorage('product_data', data)
            }
        }
        const server_env = SharedConsts.SERVER_ALLOWED
        if(server_env.includes(environment.environment) && maintenance_mode && !state.url.includes('/maintenance')){
            this.sharedService.setIpAddress()
        }
        else if (server_env.includes(environment.environment) && maintenance_mode && state.url.includes('/maintenance')){
            return true;
        }
        else if (server_env.includes(environment.environment) && !maintenance_mode && state.url.includes('/maintenance')){
            this.router.navigate(['/home']);
            return false;
        }
        else if (currentuser && currentuser !== 'undefined'  && currentuser.is_temporary_password && state.url.includes('/profile/reset-password')){
            return true
        }
        else if (currentuser && currentuser !== 'undefined'  && !currentuser.is_temporary_password && (state.url.includes('/profile/reset-password') )){
            this.router.navigate(['/']);
            return false;
        }
        else if (currentuser && currentuser !== 'undefined'  && !currentuser.is_temporary_password) {
            return true;
        }
        else if (currentuser && currentuser !== 'undefined' && currentuser.is_temporary_password){
            this.router.navigate(['profile/reset-password']);
            return true
        }
        else {
            this.router.navigate(['users/login']);
            return false;
        }
        
    }

}
